import {
  getAffiliatePumps,
  postAffiliatePump, putAffiliatePump,
  exportAffiliatePumps, importAffiliatePumps,
} from '../../../Api/services/backoffice';

export const key = 'affiliatePump';

const entityName = {
  singular: 'Bomba da Filial',
  plural: 'Bombas das Filiais',
};

const queries = {
  list: { key, fn: getAffiliatePumps },
  detail: { key },
};

const mutations = {
  create: postAffiliatePump,
  update: putAffiliatePump,
};

const fields = {
  table: [
    { key: 'bomb.name', label: 'Bomba' },
    { key: 'affiliate.name', label: 'Filial' },
    { key: 'price', label: 'Preço' },
    { key: 'cost', label: 'Custo' },
    { key: 'mcRule', label: 'MC Regra' },
    { key: 'minPumpLanceRate', label: 'Volume mínimo de bomba' },
    { key: 'status', label: 'Status', mustRender: { componentType: 'status' } },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  showBatchButton: true,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};

export const batchConfig = {
  entityName: entityName.plural,
  exportFn: exportAffiliatePumps,
  importFn: importAffiliatePumps,
};
